import React, { useState, useEffect } from 'react';
import Button from '@legacy-vfuk/core-button'
import LoadingSpinner from '@legacy-vfuk/core-loading-spinner';
import ShowError from '../../SectionAssessment/ShowError';
import AccordionData from './AccordionData';
import "../css/SearchResults.css";
import { SearchResultsTypes, TagsCountType } from '../Types/SearchResultsTypes';
import { renderRichText } from '@vhub/gatsby-source-contentful/rich-text';
import options from '../../../../../helpers/ContentFulOptions';
import { LoadingSpinnerWrapper } from './styles/SearchResults.styles';
import fireButtonAndLinkClicksEvent from '../../../../../helpers/fireButtonAndLinkClicksEvent';

const SearchResults = ({ results, contenfuldata, tagsList, questiontext, getDocumentListAPI, setSelectedTags, selectedTags,
    pagenationTotalPages, dropdown, error, tagResults, tagResultsLoader, cancel, resultCount, votesList, LanguageErrorText,
    retryBtnProp }: SearchResultsTypes) => {
    const [tagscount, setTagsCount] = useState<TagsCountType>({ start: 0, end: contenfuldata.searchTagText.tagsLimit });
    const [showmoreTags, setShowMoreTags] = useState<boolean>(false);
    const [tagString, setTagString] = useState<string>("");
    const tagListSize = 15;

    const tagsViewController = async () => {
        if (tagsList.length > tagscount.end) {
            if (tagsList.length <= tagscount.end + tagListSize) {
                setShowMoreTags(!showmoreTags);
            }
            setTagsCount({ start: 0, end: tagscount.end + tagListSize });
        } else {
            setTagsCount({ start: 0, end: !showmoreTags ? tagsList.length : contenfuldata.searchTagText.tagsLimit });
            setShowMoreTags(!showmoreTags);
        };
    };

    useEffect(() => {
        setShowMoreTags(false);
        setTagsCount({ start: 0, end: 5 });
    }, [results]);

    const activateBtn = (e: any, keywordprop: string) => {
        if (e.target.id === keywordprop) {
            e.target.classList.remove("tagDiv");
            e.target.classList.add("tagdiv-active");
        } else {
            if (e.target.id === keywordprop && e.target.classList.contains("tagdiv-active")) {
                e.target.classList.remove("tagdiv-active");
                e.target.classList.add("tagDiv");
            };
        };
    };

    const searchResultsBytag = async (keywordprop: any) => {
        fireButtonAndLinkClicksEvent({ event_label: keywordprop, event_action: 'category filter', event_category: 'smart search' });
        const filtered = selectedTags.filter((obj: any) => {
            return obj === keywordprop;
        });
        if (filtered.length === 0) {
            selectedTags.splice(0, 0, keywordprop);
            const findIndexRemoveTag = tagsList.indexOf(keywordprop);
            if (findIndexRemoveTag > -1) {
                tagsList.splice(findIndexRemoveTag, 1);
            };
        } else {
            const findIndexRemoveTag = selectedTags.indexOf(keywordprop);
            if (findIndexRemoveTag > -1) {
                selectedTags.splice(findIndexRemoveTag, 1);
                tagsList.splice(0, 0, keywordprop);
            };
            setSelectedTags(selectedTags);
        };

        if (selectedTags.length > 0) {
            const stringForTags = selectedTags.join(',');
            setTagString(stringForTags);
            await getDocumentListAPI(questiontext, dropdown, "", stringForTags);
        } else {
            await getDocumentListAPI(questiontext, dropdown, "");
        };
    };

    const retryTagApi = () => {
        getDocumentListAPI(questiontext, dropdown, "", tagString);
    };

    const disclaimerText = contenfuldata?.disclaimer?.raw && renderRichText(contenfuldata?.disclaimer, options);

    const searchResultsJSX = (
        <div className="search-results-section" >
            <div className="search-results-line"></div>
            <br />
            <div className="resultWrapper">
                <div className="resultCountline">{resultCount} {contenfuldata.searchTagText.resultForText}
                    <span className="resultTxtline">{JSON.stringify(questiontext)}</span>
                </div>
            </div>
            {LanguageErrorText && <div className='laguageError' >{LanguageErrorText}</div>}
            <div className="relTags">{contenfuldata.searchTagText.tagDespText}</div>
            {/*tags section opened */}
            <div className="sortedWrapper">
                {selectedTags.length !== 0 && selectedTags.slice(tagscount.start, tagscount.end >= 5 ? tagscount.end : selectedTags.length).map((sltag: any, index: number) => (
                    <div className="sortedTags" key={index}>
                        <div id={sltag.replace(/\s+/g, '-')}
                            className="tagdiv-active"
                            onClick={(e: any) => { cancel(); activateBtn(e, sltag); searchResultsBytag(sltag) }}>
                            {sltag}
                        </div>
                    </div>
                ))}
                {tagsList.slice(tagscount.start, tagscount.end < selectedTags.length ? 0 : tagscount.end - selectedTags.length).map(
                    (keyword: any, index: number) => (
                        <div className="sortedTags" key={index}>
                            <div id={keyword.replace(/\s+/g, '-')} className="tagDiv" onClick={(e: any) => { cancel(); searchResultsBytag(keyword); }}>
                                {keyword}
                            </div>
                        </div>
                    ))
                }
                {tagsList.length + selectedTags.length > contenfuldata.searchTagText.tagsLimit &&
                    <div className="showmoretags-section">
                        <div onClick={tagsViewController} className="showmoretags-text" >
                            <Button
                                text= { showmoreTags ? contenfuldata.searchTagText.showLessText : contenfuldata.searchTagText.showMoreText }
                                icon={{
                                    name: showmoreTags ? 'chevron-up' : 'chevron-down',
                                    justify: 'right',
                                }}
                                width='auto'
                            />
                        </div>
                    </div>
                }
            </div>
            {/*tags section ended*/}
            {/* accordian section started*/}
            {tagResultsLoader === true ?
                <div>
                    {error ?
                        <ShowError errorContent={error.errorContent} errorType={error.errorType}
                            customParam={retryTagApi}
                        />
                        :
                        <LoadingSpinnerWrapper>
                            <LoadingSpinner size={5} appearance='secondary' />
                        </LoadingSpinnerWrapper>
                    }
                </div> :
                <AccordionData results={tagResults.length !== 0 ? tagResults : results}
                    pagenationTotalPages={pagenationTotalPages} dropdown={dropdown}
                    getDocumentListAPI={getDocumentListAPI} questiontext={questiontext}
                    content={contenfuldata} error={error} tagString={tagString}
                    votesList={votesList}
                />
            }
            {
                disclaimerText && <p className='search-disclaimer-text'>{disclaimerText}</p>
            }
        </div>
    );

    const searchErrorJSX = (
        <div style={{ marginTop: 30 }}>
            <div className="search-results-line" ></div>
            <div className="resultWrapper">
                <div className="resultCountline">{results.length} {contenfuldata.searchTagText.resultForText}
                    <span className="resultTxtline">{JSON.stringify(questiontext)}</span>
                </div>
            </div>
            {
                error && <ShowError errorContent={error.errorContent} errorType={error.errorType} customParam={retryBtnProp}/>
            }
        </div>
    );

    const searchLoaderJSX = (
        <LoadingSpinnerWrapper>
            <LoadingSpinner size={5} appearance='secondary' />
        </LoadingSpinnerWrapper>
    );

    if (!results || results.length < 1) {
        return error ? searchErrorJSX : searchLoaderJSX;
    };

    return searchResultsJSX;

};

export default SearchResults;
